import { combineReducers } from 'redux';
import eventsReducer from './eventsReducer';
import editReducer from './editReducer';
import resultsReducer from './resultsReducer';
import winnersReducer from './winnersReducer';

import auth from './auth'

import { reducer as formReducer } from 'redux-form'
import { actionTypes } from '../actions/types'

export default combineReducers({
  events: eventsReducer,
  results: resultsReducer,
  winners: winnersReducer,
  auth: auth,
  form: formReducer.plugin({
    eventForm: (state, action) => { // <------ 'eventForm' is name of form given to reduxForm()
      switch(action.type) {
        case actionTypes.CLEAR_EVENT:
          return undefined;       // <--- blow away form data
        case actionTypes.FETCH_EVENTS:
            return undefined;       // <--- blow away form data
        default:
          return state;
      }
    }
  }),
  edits: editReducer
});
